import React from 'react'

const EmbeddedApp = () => {
    return (
        <iframe 
            className='w-full h-screen' 
            src='https://geoxc-apps2.bd.esri.com/LivingAtlas/GlobalLandCoverChangePrediction/index.html'
        />
    )
}

export default EmbeddedApp
